module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAA+0lEQVQokY2SsWoCQRCGFysLsZUQMGCbswyEtJJ3kGAn2KVUS0kqmzxCSJEijURs7NOmsBJBEAsLRcUmL/CFOUcZN3dZB/5d7r//gxl2HGAVAV1gzL5WwCtw7+Vi2Y8W/9dHGmzBJ+AayANXQF07kBr4cMmAUVJ7QBaYaaZq4Rc1OyngQbeam1h4qWYhAIu2Nptxzl24fe1cuEaauJFD4B81cmfARb0X8Qm8ayu1QMvSKtr6ceY7NTcBeKi5B/+de/pjnLBN8uaf5jllJ/5sWN8E1sAXME3ZOVmkE1jUAL694Bx4BNqe30yb7xKoAGXPf7Z0aCmSJDMvgbdf22KSfmEBqNgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon6.png
// module id = MLRA
// module chunks = 42